/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ShiftInfoList } from '../../models/shift-info-list';

export interface GetShiftInfos$Params {
  workCenterId: number;
  approvalReportDate: string;
}

export function getShiftInfos(http: HttpClient, rootUrl: string, params: GetShiftInfos$Params, context?: HttpContext): Observable<StrictHttpResponse<ShiftInfoList>> {
  const rb = new RequestBuilder(rootUrl, getShiftInfos.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
    rb.path('approvalReportDate', params.approvalReportDate, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ShiftInfoList>;
    })
  );
}

getShiftInfos.PATH = '/api/v1/workCenter/{workCenterId}/approvals/{approvalReportDate}/shifts/info';
